// Uzbek (Latin) translations. Keys are dotted namespace.string pairs.
// Keep this file in sync with i18n.ru.ts — every key must exist in both.

const uz: Record<string, string> = {
  // ── A11y ───────────────────────────────────────────────────────────────
  "a11y.skip_to_content": "Asosiy mazmunga o'tish",
  "a11y.nav_primary": "Asosiy navigatsiya",

  // ── Navigation ─────────────────────────────────────────────────────────
  "nav.home": "Bosh sahifa",
  "nav.gallery": "Shablonlar",
  "nav.dashboard": "Mening taklifim",
  "nav.help": "Yordam",
  "nav.cart": "Savat",
  "nav.signin": "Kirish",
  "nav.menu": "Menyu",
  "nav.signout": "Chiqish",
  "nav.pricing": "Narxlar",

  // ── Common actions ────────────────────────────────────────────────────
  "common.save": "Saqlash",
  "common.cancel": "Bekor qilish",
  "common.delete": "O'chirish",
  "common.edit": "Tahrirlash",
  "common.preview": "Ko'rinish",
  "common.publish": "Faollashtirish",
  "common.loading": "Yuklanmoqda...",
  "common.back": "Orqaga",
  "common.next": "Keyingi",
  "common.continue": "Davom etish",
  "common.close": "Yopish",
  "common.open": "Ochish",
  "common.search": "Qidirish",
  "common.send": "Yuborish",
  "common.submit": "Yuborish",
  "common.confirm": "Tasdiqlash",
  "common.yes": "Ha",
  "common.no": "Yo'q",
  "common.error": "Xatolik yuz berdi",
  "common.retry": "Qayta urinish",
  "common.copy": "Nusxa olish",
  "common.copied": "Nusxa olindi",
  "common.optional": "ixtiyoriy",
  "common.required": "majburiy",

  // ── RSVP ──────────────────────────────────────────────────────────────
  "rsvp.title": "Sizni kutamiz.",
  "rsvp.yes": "Albatta kelaman",
  "rsvp.no": "Kelolmayman",
  "rsvp.maybe": "Hali aniq emas",
  "rsvp.name": "Ismingiz",
  "rsvp.party_size": "Necha kishi keladi",
  "rsvp.message": "Xabar (ixtiyoriy)",
  "rsvp.submit": "Javob yuborish",
  "rsvp.thanks": "Javobingiz uchun rahmat",

  // ── Sharing ───────────────────────────────────────────────────────────
  "share.title": "Yaqinlaringizga ulashing",
  "share.copy": "Havolani nusxa olish",
  "share.copied": "Nusxa olindi",
  "share.telegram": "Telegram",
  "share.whatsapp": "WhatsApp",
  "share.native": "Ulashish",
  "share.qr": "QR kod",

  // ── Calendar ──────────────────────────────────────────────────────────
  "calendar.add": "Kalendarga qo'shish",
  "calendar.download": "ICS faylni yuklab olish",

  // ── Music ─────────────────────────────────────────────────────────────
  "music.title": "Musiqa tanlang",
  "music.none": "Musiqasiz",
  "music.play": "Tinglash",
  "music.pause": "To'xtatish",
  "music.premium": "Premium",

  // ── Editor ────────────────────────────────────────────────────────────
  "editor.title": "Taklifni tahrirlash",
  "editor.names": "Ismlar",
  "editor.date": "Sana",
  "editor.time": "Vaqt",
  "editor.venue": "Joy",
  "editor.address": "Manzil",
  "editor.map_url": "Karta havolasi",
  "editor.story": "Hikoyamiz",
  "editor.photos": "Fotosuratlar",
  "editor.schedule": "Dasturi",

  // ── Auth ──────────────────────────────────────────────────────────────
  "auth.email": "Email",
  "auth.code": "Tasdiqlash kodi",
  "auth.send_code": "Kod yuborish",
  "auth.verify": "Tasdiqlash",
  "auth.welcome": "Xush kelibsiz",

  // ── Errors ────────────────────────────────────────────────────────────
  "error.network": "Internet aloqasi bilan muammo",
  "error.notfound": "Topilmadi",
  "error.forbidden": "Ruxsat yo'q",

  // ── Landing hero ──────────────────────────────────────────────────────
  "landing.hero.eyebrow": "N°01 — Raqamli taklifnomalar",
  "landing.hero.headline_1": "Har bir tantana",
  "landing.hero.headline_2": "o'z hikoyasiga",
  "landing.hero.headline_3": "loyiq.",
  "landing.hero.body": "To'y, nikoh, beshik to'y va boshqa muhim kunlar uchun zamonaviy va nafis raqamli taklifnomalar. Bir necha daqiqada — umrbod xotira.",
  "landing.hero.trust": "Har bir shablon — dizayner qo'lidan chiqqan mualliflik ish",
  "landing.cta.browse": "Shablonlarni ko'rish →",
  "landing.cta.how": "Qanday ishlaydi",
  "landing.hero.handcrafted": "handcrafted",

  // ── Landing stats ─────────────────────────────────────────────────────
  "landing.stats.templates": "shablon",
  "landing.stats.setup": "tayyorlash",
  "landing.stats.sent": "yuborilgan",
  "landing.stats.languages": "tilda",
  "landing.stats.coming": "shablon yo'lda",
  "landing.stats.setup_value": "12 daq.",

  // ── Landing marquee ───────────────────────────────────────────────────
  "landing.marquee.wedding": "To'y",
  "landing.marquee.nikoh": "Nikoh",
  "landing.marquee.beshik": "Beshik to'y",
  "landing.marquee.birthday": "Tug'ilgan kun",
  "landing.marquee.jubilee": "Yubiley",
  "landing.marquee.corporate": "Korporativ",
  "landing.marquee.memorial": "Xotira",

  // ── Landing trending (N°02) ───────────────────────────────────────────
  "landing.trending.eyebrow": "N°02 — Yangi taklifnomalar",
  "landing.trending.headline_1": "Eng yangi",
  "landing.trending.headline_2": "qo'shilganlar",

  // ── Landing categories ────────────────────────────────────────────────
  "landing.categories.eyebrow": "N°03 — Shablonlar",
  "landing.categories.headline_1": "Har qanday",
  "landing.categories.headline_2": "tantana",
  "landing.categories.headline_3": "uchun.",
  "landing.categories.see_all": "Hammasini ko'rish",

  // ── Landing featured ──────────────────────────────────────────────────
  "landing.featured.eyebrow": "N°04 · TANLOV",
  "landing.featured.headline_1": "Mavsumning",
  "landing.featured.headline_2": "eng sevimli",
  "landing.featured.headline_3": "shablonlari.",

  // ── Landing how it works ──────────────────────────────────────────────
  "landing.how.eyebrow": "N°05 — Qanday ishlaydi",
  "landing.how.headline_1": "To'rt qadam — va",
  "landing.how.headline_2": "taklifnomangiz tayyor.",
  "landing.how.step1.title": "Tanlang",
  "landing.how.step1.desc": "240+ shablondan o'zingizga moslarini tanlang.",
  "landing.how.step2.title": "Shaxsiylashtiring",
  "landing.how.step2.desc": "Ismlar, sana, manzil va matnni o'zgartiring.",
  "landing.how.step3.title": "To'lang",
  "landing.how.step3.desc": "Payme, Click, Uzcard yoki Humo orqali to'lang.",
  "landing.how.step4.title": "Ulashing",
  "landing.how.step4.desc": "Mehmonlaringizga link orqali yuboring.",

  // ── Landing testimonial ───────────────────────────────────────────────
  "landing.testimonial.eyebrow": "N°06 — Mehmonlar fikri",
  "landing.testimonial.quote": "\"Bizning to'yimizga yarashgan eng chiroyli taklifnoma. Mehmonlarimiz 'qog'ozli emas-mi?' deb ajablanishdi — shu qadar nafis.\"",
  "landing.testimonial.location": "Tashkent · 2026",
  "landing.testimonial.ratings": "3,200+ baho",
  "landing.testimonial.recommend": "tavsiya etadi",

  // ── Landing final CTA ─────────────────────────────────────────────────
  "landing.final.headline_1": "Tantanangizni",
  "landing.final.headline_2": "boshlaylik.",
  "landing.final.body": "Bugun shablon tanlang va ertaga mehmonlaringizni xursand qiling.",

  // ── Categories ────────────────────────────────────────────────────────
  "category.all": "Hammasi",
  "category.bookie": "Bookie",
  "category.wedding": "To'y",
  "category.nikoh": "Nikoh",
  "category.birthday": "Tug'ilgan kun",
  "category.beshik": "Beshik to'y",
  "category.corporate": "Korporativ",
  "category.memorial": "Xotira",
  "category.yubiley": "Yubiley",
  "category.fotixa": "Fotixa",
  "category.sunnat": "Sunnat to'y",
  "category.graduation": "Bitiruv",
  "category.uy": "Yangi uy",
  "category.sevgi": "Sevgi kuni",
  "category.iftor": "Iftor",

  // ── Tier badges ───────────────────────────────────────────────────────
  "tier.bestseller": "Bestseller",
  "tier.premium": "Premium",
  "tier.new": "Yangi",
  "tier.standard": "Standart",

  // ── Common (extras) ───────────────────────────────────────────────────
  "common.coming_soon": "Tez kunda",

  // ── Gallery page ──────────────────────────────────────────────────────
  "gallery.eyebrow": "Kolleksiya",
  "gallery.headline_1": "Barcha",
  "gallery.headline_2": "shablonlar",
  "gallery.count": "{count} ta shablon",
  "gallery.sort.popular": "Mashhur",
  "gallery.sort.price_asc": "Arzon → Qimmat",
  "gallery.sort.price_desc": "Qimmat → Arzon",
  "gallery.sort.label": "Saralash",
  "gallery.sort.newest": "Yangi",
  "gallery.categories.more": "Ko'proq",
  "gallery.categories.allLabel": "Barcha toifalar",
  "gallery.close": "Yopish",
  "gallery.empty": "Hech narsa topilmadi",

  // ── Template detail page ──────────────────────────────────────────────
  "detail.device.site": "Sayt",
  "detail.device.card": "Kartochka",
  "detail.device.phone": "Telefon",
  "detail.fullscreen": "To'liq ekranda ko'rish →",
  "detail.preview_caption": "Jonli ko'rinish · scroll qilib ko'ring",
  "detail.premium_caption": "✦ Premium quality",
  "detail.description": "To'liq saytga aylanadigan raqamli taklifnoma. Ismlar, sana, manzil, foto albom, RSVP, musiqa, mehmonlar kitobi — barchasi bitta linkda.",
  "detail.price_caption": "Bir martalik to'lov · cheksiz mehmon",
  "detail.customize": "Shaxsiylashtirish",
  "detail.feature.guests.title": "Cheksiz mehmonlar",
  "detail.feature.guests.caption": "Soniga cheklov yo'q",
  "detail.feature.rsvp.title": "RSVP qabul qilish",
  "detail.feature.rsvp.caption": "Javob va statistika",
  "detail.feature.link.title": "Shaxsiy link",
  "detail.feature.link.caption": "taklifla.uz/ismingiz",
  "detail.feature.gallery.title": "Foto galereya",
  "detail.feature.gallery.caption": "10 tagacha rasm",
  "detail.feature.music.title": "Musiqa",
  "detail.feature.music.caption": "Background ovoz",
  "detail.feature.guestbook.title": "Mehmonlar kitobi",
  "detail.feature.guestbook.caption": "Tabriklarni qabul qilish",
  "detail.buy": "Davom etish · {price}",
  "detail.owned_cta": "Sizning taklifnomangizni ochish",
  "detail.preparing": "Tayyorlanmoqda…",
  "detail.favorite": "Sevimlilarga qo'shish",
  "detail.buy_error_fallback": "Tayyorlashda xatolik. Iltimos, qayta urinib ko'ring.",
  "detail.payment_methods": "Payme · Click · Uzcard · Humo · Visa · Mastercard",
  "detail.related.title_1": "Yana",
  "detail.related.title_2": "ko'rishingiz",
  "detail.related.title_3": "mumkin",
  "detail.related.all": "Hammasi",

  // ── Checkout page ─────────────────────────────────────────────────────
  "checkout.breadcrumb.dashboard": "Boshqaruv",
  "checkout.breadcrumb.payment": "To'lov",
  "checkout.summary.eyebrow": "Buyurtma tafsilotlari",
  "checkout.summary.title": "Sizning taklifnomangiz",
  "checkout.subtotal": "Subtotal",
  "checkout.promo": "Promo",
  "checkout.total": "Jami",
  "checkout.cancel": "← Boshqaruvga qaytish",
  "checkout.payment.eyebrow": "To'lov usuli",
  "checkout.payment.title": "Qulay variantni tanlang",
  "checkout.payment.payme.label": "Payme",
  "checkout.payment.payme.sublabel": "Eng mashhur to'lov tizimi",
  "checkout.payment.click.label": "Click",
  "checkout.payment.click.sublabel": "Karta orqali to'lash",
  "checkout.payment.uzcard.label": "Uzcard / Visa",
  "checkout.payment.uzcard.sublabel": "Bank kartalari",
  "checkout.promo.label": "Promo kod",
  "checkout.promo.placeholder": "Masalan: TAKLIF10",
  "checkout.promo.apply": "Qo'llash",
  "checkout.promo.unavailable": "Promo kodlar tez kunda ishga tushadi",
  "checkout.pay": "To'lash · {total}",
  "checkout.payment_unavailable": "Hali to'lov tizimlari ulanmagan — tez kunda",
  // Payme branding strings.
  "checkout.payWith": "To'lash · Payme",
  "checkout.secure": "Xavfsiz to'lov · Payme orqali",
  "checkout.poweredBy": "Derio Technologies MCHJ",
  // Shared payment-state strings.
  "checkout.already_paid": "Bu taklifnoma allaqachon faollashtirilgan.",
  "checkout.go_editor": "Tahrirlashga o'tish →",
  "checkout.coming_soon.title": "To'lov tizimi tez kunda",
  "checkout.coming_soon.body": "Payme/Click integratsiyasi hozircha ushbu muhitda yoqilmagan. Iltimos, keyinroq qayta urinib ko'ring.",
  // Real payments — Payme primary, Click optional secondary.
  "checkout.pay.body": "Payme orqali xavfsiz to'lang. To'lov tasdiqlangach taklifnomangiz darhol faollashadi.",
  "checkout.pay.payme": "Payme orqali to'lash · {total}",
  "checkout.pay.click": "Click orqali to'lash · {total}",
  "checkout.pay.redirecting": "To'lov tizimiga yo'naltirilmoqda…",
  "checkout.pay.disclaimer": "To'lov tasdiqlangach taklifnomangiz darhol faollashadi.",
  "checkout.pay.error_generic": "To'lovni boshlab bo'lmadi. Qaytadan urinib ko'ring.",
  // Return-from-gateway page.
  "payment.return.missing.title": "To'lov ma'lumoti yo'q",
  "payment.return.missing.body": "Buyurtma identifikatori topilmadi. Iltimos, taklifnomangizdan to'lovni qaytadan boshlang.",
  "payment.return.go_dashboard": "Boshqaruvga qaytish",
  "payment.return.polling.title": "To'lov tasdiqlanmoqda",
  "payment.return.polling.body": "To'lov tizimi javobini kutyapmiz. Bu jarayon bir necha soniya davom etishi mumkin.",
  "payment.return.polling.hint": "Sahifani yopmang.",
  "payment.return.paid.title": "To'lov muvaffaqiyatli!",
  "payment.return.paid.body": "Taklifnomangiz faollashtirildi. Endi tahrirlash va do'stlaringiz bilan ulashish mumkin.",
  "payment.return.paid.cta_editor": "Tahrirlashga o'tish",
  "payment.return.cancelled.title": "To'lov bekor qilindi",
  "payment.return.cancelled.body": "Hech qanday pul yechib olinmadi. Istalgan vaqtda qayta urinib ko'rishingiz mumkin.",
  "payment.return.cancelled.try_again": "Qayta urinish",
  "payment.return.failed.title": "To'lov amalga oshmadi",
  "payment.return.failed.body": "To'lov tizimi tomonidan rad etildi. Boshqa karta yoki usul bilan urinib ko'ring.",
  "payment.return.timeout.title": "Javob kutilmoqda",
  "payment.return.timeout.body": "To'lov tizimi hali javob bermadi. Bir necha daqiqadan so'ng qayta tekshiring — agar mablag' yechilgan bo'lsa, taklifnoma avtomatik faollashadi.",
  "payment.return.timeout.retry": "Qayta tekshirish",
  "payment.return.error.title": "Xatolik yuz berdi",
  "payment.return.error.not_found": "Buyurtma topilmadi.",
  "checkout.trust": "Xavfsiz to'lov · 256-bit SSL · Payme va Click rasmiy hamkor",
  "checkout.notfound.eyebrow": "Taklifnoma topilmadi",
  "checkout.notfound.title": "Bunday buyurtma yo'q",
  "checkout.notfound.body": "Havolani tekshirib ko'ring yoki shablonlar bo'limidan yangi taklifnoma yarating.",
  "checkout.notfound.cta": "Shablonlarni ko'rish",
  "checkout.notfound.cta_dashboard": "Boshqaruv paneli",
  "checkout.error.title": "Xatolik",
  "checkout.error.fallback": "Taklifnomani yuklab bo'lmadi",
  "checkout.error.back": "Boshqaruv paneliga qaytish",
  "checkout.promise.free": "Cheksiz mehmonlar · doimiy",
  "checkout.promise.premium": "Abadiy faol · suv belgisi yo'q · ustuvor qo'llab-quvvatlash",
  "checkout.payment.coming_soon": "Tez kunda",
  "checkout.breadcrumb.home": "Bosh",

  // ── Detail page extras ───────────────────────────────────────────────
  "detail.breadcrumb.home": "Bosh",
  "detail.breadcrumb.gallery": "Shablonlar",

  // ── Gallery page extras ──────────────────────────────────────────────
  "gallery.search.placeholder": "Qidirish...",

  // ── Sections (guest variants UI shell) ───────────────────────────────
  "sections.countdown.eyebrow": "BAYRAMGACHA QOLDI",
  "sections.countdown.day": "KUN",
  "sections.countdown.hour": "SOAT",
  "sections.countdown.minute": "DAQIQA",
  "sections.countdown.second": "SONIYA",
  "sections.countdown.passed": "MAROSIM O'TDI",
  "sections.schedule.eyebrow": "BAYRAM TARTIBI",
  "sections.schedule.title": "Kun davomida",
  "sections.rsvp.eyebrow": "JAVOB BERING",
  "sections.map.eyebrow": "MANZIL",
  "sections.map.title": "Bizni toping",
  "sections.map.open": "Yandex Maps'da ochish →",
  "sections.map.loading": "XARITA YUKLANMOQDA…",
  "sections.gallery.eyebrow": "FOTO ALBOM",
  "sections.gallery.title": "Bizning daqiqalarimiz",
  "sections.guestbook.title": "Tilak yozing",
  "sections.guestbook.placeholder": "Tabriklaringizni yozing...",
  "sections.guestbook.name_placeholder": "Ismingiz",
  "sections.guestbook.send": "Yuborish →",
  "sections.guestbook.sending": "Yuborilmoqda…",
  "sections.guestbook.ok": "✓ Tilakingiz qabul qilindi",
  "sections.guestbook.err": "Yuborib bo'lmadi — qaytadan urinib ko'ring",
  "sections.guestbook.closed.eyebrow": "DAFTAR YOPILDI",
  "sections.guestbook.closed.title": "Bayram o'tdi — rahmat",
  "sections.guestbook.closed.body": "Yangi tilaklarni qabul qilish to'xtatildi. Mehmonlar qoldirgan so'zlar bayram esi sifatida saqlanadi.",
  "sections.guestbook.closed.count": "{count} ta tilak qoldirildi",
  "sections.footer.signature": "MADE WITH TAKLIFLA.UZ",
  "sections.lightbox.close": "Yopish",

  // ── Dashboard ────────────────────────────────────────────────────────
  "dashboard.eyebrow": "Boshqaruv paneli",
  "dashboard.greeting": "Salom, {name}",
  "dashboard.subtitle": "Sizning taklifnomalaringiz va ularning holati shu yerda.",
  "dashboard.new": "Yangi taklifnoma +",
  "dashboard.empty.title": "Hali taklifnoma yo'q",
  "dashboard.empty.body": "Birinchi taklifnomangizni yaratish uchun shablonlar galereyasiga o'ting.",
  "dashboard.empty.cta": "Shablonlarni ko'rish →",
  "dashboard.error.eyebrow": "Xato",
  "dashboard.error.body": "Taklifnomalarni yuklab bo'lmadi: {message}",
  "dashboard.error.unknown": "noma'lum xato",
  "dashboard.retry": "Qayta urinish ↻",
  "dashboard.signin.title": "Mening taklifim",
  "dashboard.signin.body": "O'z taklifnomalaringizni boshqarish uchun avval kirishingiz kerak.",
  "dashboard.signin.cta": "Kirish →",
  "dashboard.account": "Akkaunt",
  "dashboard.guest": "Mehmon",
  "dashboard.unnamed": "Nomsiz taklifnoma",
  "dashboard.no_date_venue": "Sana va manzil ko'rsatilmagan",
  "dashboard.status.published": "Faol",
  "dashboard.status.expired": "Muddati o'tgan",
  "dashboard.status.draft": "Qoralama",
  "dashboard.action.edit": "Tahrirlash",
  "dashboard.action.view": "Ko'rish ↗",
  "dashboard.action.publish": "Faollashtirish →",
  "dashboard.action.publishing": "Faollashtirilmoqda…",
  "dashboard.menu.more": "Yana",
  "dashboard.menu.publish": "Faollashtirish",
  "dashboard.menu.copy_link": "Havoladan nusxa olish",
  "dashboard.menu.open_new": "Yangi oynada ko'rish",
  "dashboard.menu.delete": "O'chirish",
  "dashboard.menu.unpublish": "Maxfiy qilish",
  "dashboard.copy.copied": "✓ Nusxa olindi",
  "dashboard.copy.action": "nusxa olish",
  "dashboard.copy.fallback_prompt": "Havoladan nusxa oling:",
  "dashboard.copy.aria": "Havoladan nusxa olish",
  "dashboard.confirm_delete": "\"{name}\" haqiqatan ham o'chirilsinmi?\n\nBu amalni qaytarib bo'lmaydi.",
  "dashboard.confirm_delete.fallback": "Bu taklifnoma",
  "dashboard.confirm_unpublish": "\"{name}\" maxfiy qilinsinmi?\n\nHavola ochilmay qo'yadi, ammo taklifnoma va barcha tilaklar saqlanib qoladi — istalgan vaqtda qayta faollashtirish mumkin.",
  "dashboard.publish.success": "Taklifnoma faol! Havola: {url}",
  "dashboard.unpublish.success": "Taklifnoma maxfiy qilindi. Istalgan vaqtda qayta faollashtirishingiz mumkin.",
  "dashboard.thumb_aria": "{name} — tahrirlash",
  "dashboard.thumb_fallback": "Taklifnoma",

  // ── Editor ───────────────────────────────────────────────────────────
  "editor.eyebrow.create": "Yangi taklifnoma",
  "editor.eyebrow.edit": "Tahrirlash",
  "editor.cancel": "← Bekor qilish",
  "editor.cancel_short": "Bekor qilish",
  "editor.title.create_1": "Yangi",
  "editor.title.create_2": "taklifnoma",
  "editor.title.edit_1": "Taklifnomani",
  "editor.title.edit_2": "tahrirlash",
  "editor.template_label": "Shablon",
  "editor.status_label": "Holat",
  "editor.field.names.placeholder": "Aziza & Sardor",
  "editor.field.names.error_min": "Kamida 3 ta belgi kiriting",
  "editor.field.time.placeholder": "17:00",
  "editor.field.venue.placeholder": "Toshkent",
  "editor.field.address.placeholder": "Restoran nomi va to'liq manzil",
  "editor.field.map_url.placeholder": "https://maps.app.goo.gl/...",
  "editor.field.map_url.helper": "Ixtiyoriy. Google Maps, Apple Maps yoki Yandex'dan havola joylang — \"Karta\" tugmasi shu manzilni ochadi.",
  "editor.field.slug.label": "Manzil (URL)",
  "editor.field.slug.placeholder": "aziza-sardor",
  "editor.field.slug.auto": "Avtomatik",
  "editor.field.slug.error_format": "Faqat kichik harflar, raqamlar va '-' belgisi",
  "editor.field.slug.helper": "Mehmonlar uchun havola: taklifla.uz/i/{slug}",
  "editor.field.slug.helper_empty": "...",
  "editor.field.story.label": "Bizning hikoyamiz",
  "editor.field.story.placeholder": "Tanishuvingiz haqida qisqacha…",
  "editor.field.date.calendar": "kalendar",
  "editor.field.date.text": "matnli kiritish",
  "editor.field.date.placeholder": "12.06.2026",
  "editor.field.date.error": "Format: dd.mm.yyyy (masalan, 12.06.2026)",
  "editor.field.photos.label": "Suratlar",
  "editor.field.photos.placeholder": "Tez orada — surat yuklash",
  "editor.field.music.label": "Musiqa",
  "editor.field.music.placeholder": "Tez orada — musiqa tanlash",
  "editor.field.schedule.label": "Dasturi",
  "editor.field.schedule.empty": "Hali dastur qo'shilmagan",
  "editor.field.schedule.event_placeholder": "Mehmonlarni kutib olish",
  "editor.field.schedule.delete": "O'chirish",
  "editor.field.schedule.add": "+ Qo'shish",
  // ── Feature-driven editor blocks ─────────────────────────────────────
  "editor.feat.gallery": "Suratlar",
  "editor.feat.gallery.helper": "Eng yaxshi 3–10 ta suratni yuklang. Birinchi surat asosiy bo'ladi.",
  "editor.feat.schedule": "Tadbir dasturi",
  "editor.feat.agenda": "Kun tartibi",
  "editor.feat.timeline": "Muhim sanalar",
  "editor.feat.timeline.ph_a": "Yil",
  "editor.feat.timeline.ph_b": "Voqea",
  "editor.feat.speakers": "Notiqlar",
  "editor.feat.speakers.ph_a": "Ism familiya",
  "editor.feat.speakers.ph_b": "Lavozim",
  "editor.feat.wishlist": "Sovg'alar ro'yxati",
  "editor.feat.wishlist.helper": "Mehmonlar uchun sovg'a g'oyalari yoki havola.",
  "editor.feat.dresscode": "Kiyim uslubi",
  "editor.feat.dresscode.helper": "Masalan: rasmiy, oq-qora ranglar, milliy libos",
  "editor.feat.quran": "Oyat / duo",
  "editor.feat.quran.ph": "Marosimda o'qiladigan oyat yoki duoni kiriting…",
  "editor.feat.bio": "Tarjimai hol",
  "editor.feat.bio.ph": "Marhum haqida bir necha so'z — tug'ilgan yili, hayot yo'li…",
  "editor.feat.story.love": "Sevgi tarixingiz",
  "editor.feat.story.love.ph": "Qanday tanishgansiz, qanday qaror qilgansiz — qisqacha hikoya…",
  "editor.feat.story.person": "Qahramon haqida",
  "editor.feat.story.person.ph": "Bayram egasi haqida bir necha iliq so'z…",
  "editor.feat.story.child": "Quvonchli kun haqida",
  "editor.feat.story.child.ph": "Farzandingiz va ushbu quvonchli kun haqida…",
  "editor.feat.story.memorial": "Xotira so'zlari",
  "editor.feat.story.memorial.ph": "Marhum haqidagi xotira va iliq so'zlar…",
  "editor.feat.story.event": "Tadbir haqida",
  "editor.feat.story.event.ph": "Ushbu tadbir haqida qisqacha ma'lumot…",
  "editor.list.add": "+ Qo'shish",
  "editor.list.empty": "Hali qo'shilmagan",
  "editor.list.remove": "O'chirish",
  "editor.save": "Saqlash",
  "editor.saving": "Saqlanmoqda…",
  "editor.publish": "Faollashtirish →",
  "editor.publish_short": "Faollashtirish",
  "editor.publishing": "Faollashtirilyapti…",
  "editor.publish_disabled.not_draft": "Faqat qoralama holatdagi taklifnomalarni faollashtirish mumkin",
  "editor.publish_disabled.fields": "Barcha majburiy maydonlarni to'ldiring",
  "editor.error.save": "Saqlashda xatolik yuz berdi",
  "editor.error.publish": "Faollashtirishda xatolik yuz berdi",
  "editor.error.names_min": "Ismlar kamida 3 ta belgidan iborat bo'lishi kerak",
  "editor.error.slug_format": "Slug noto'g'ri formatda. Faqat a-z, 0-9 va '-' belgilari ruxsat etiladi.",
  "editor.error.required_fields": "Faollashtirishdan oldin barcha majburiy maydonlarni to'ldiring",
  "editor.toast.saved": "Saqlandi",
  "editor.toast.published": "Taklifnoma faollashtirildi",
  // Editor — share panel (after publish)
  "editor.share.eyebrow": "Nashr etildi · ulashishga tayyor",
  "editor.share.title": "Sizning taklifnomangiz tirik",
  "editor.share.body": "Quyidagi havolani mehmonlaringizga yuboring — har biriga bitta unikal manzil.",
  "editor.share.copy": "Nusxa olish",
  "editor.share.copied": "✓ Nusxa olindi",
  "editor.share.copy_fallback": "Nusxa olish uchun belgilang",
  "editor.share.whatsapp": "WhatsApp",
  "editor.share.telegram": "Telegram",
  "editor.share.open": "Ochish ↗",
  "editor.share.message": "Sizni taklifnomamizga taklif qilamiz",
  "editor.share.expires": "Faollik muddati:",
  // Editor — wishbook moderation
  "editor.wishes.eyebrow": "Mehmonlar tilaklari",
  "editor.wishes.title": "Tilaklarni boshqarish",
  "editor.wishes.body": "Mehmonlardan kelgan barcha tilaklar bu yerda. Yoqimsiz yoki noto'g'ri xabarni oching va o'chiring.",
  "editor.wishes.count_suffix": "ta tilak",
  "editor.wishes.loading": "Yuklanyapti…",
  "editor.wishes.error": "Tilaklarni yuklab bo'lmadi",
  "editor.wishes.empty": "Hozircha tilak yo'q. Birinchi mehmon yozsa, shu yerda paydo bo'ladi.",
  "editor.wishes.delete": "O'chirish",
  "editor.wishes.deleting": "O'chirilmoqda…",
  "editor.wishes.confirm_delete": "Bu tilakni o'chirilsinmi?",
  "editor.wishes.refresh": "Yangilash",
  // Help / FAQ page
  "help.eyebrow": "Yordam markazi",
  "help.title_1": "Tez-tez beriladigan",
  "help.title_2": "savollar",
  "help.lede": "Taklifla.uz dan foydalanish bo'yicha asosiy savollarga javoblar. Topa olmadingizmi? Telegram orqali yozib qoldiring — biz bir kun ichida javob beramiz.",
  "help.faq.buy.q": "Taklifnomani qanday sotib olaman?",
  "help.faq.buy.a": "Shablonlar bo'limidan dizaynni tanlang, \"Sotib olish\" tugmasini bosing va Payme orqali to'lovni amalga oshiring. To'lov tasdiqlangach taklifnoma sizning hisobingizda darhol ochiladi.",
  "help.faq.edit.q": "Sotib olganimdan keyin matnni qayerda o'zgartiraman?",
  "help.faq.edit.a": "Boshqaruv panelida (\"Mening taklifim\") sizning sotib olgan taklifnomalaringiz ro'yxati turadi. Har birining yoniga \"Tahrirlash\" tugmasi bor — shu yerdan ism, sana, manzil va musiqani o'zgartirasiz.",
  "help.faq.share.q": "Mehmonlarga havolani qanday yuboraman?",
  "help.faq.share.a": "Tahrirlashni saqlab \"Nashr etish\" tugmasini bosganingizdan so'ng yuqorida ulashish paneli paydo bo'ladi: havolani nusxalash, WhatsApp yoki Telegram orqali yuborish — bir tugma bilan.",
  "help.faq.expiry.q": "Taklifnoma qancha vaqt onlayn turadi?",
  "help.faq.expiry.a": "Sotib olingandan keyin taklifnoma muddatsiz onlayn turadi — istalgan vaqtda mehmonlar uni ochib ko'rishlari mumkin.",
  "help.faq.lifetime.q": "Taklifnoma qancha vaqt yashaydi?",
  "help.faq.lifetime.a": "Sotib olingan taklifnoma taklifla.uz xizmati ishlab turgan vaqtgacha — ehtimol, butun umr davomida — faol bo'lib turadi. Loyiha to'xtatilgan, sayt yopilgan yoki kompaniyamiz faoliyatini to'xtatgan taqdirda taklifnomalarning onlayn qolishini kafolatlay olmaymiz.",
  "help.faq.refund.q": "Pulni qaytarib olish mumkinmi?",
  "help.faq.refund.a": "To'lovlarni avtomatik qaytarish imkoniyatimiz yo'q. Agar to'lov xato bilan amalga oshirilgan bo'lsa, Telegramdagi @taklifla_bot orqali holatni qo'llab-quvvatlash xizmatiga yozing — biz har bir murojaatni alohida ko'rib chiqamiz va imkoniyat bo'lsa yordam berishga harakat qilamiz. Kafolat bermaymiz.",
  "help.contact.eyebrow": "Bog'lanish",
  "help.contact.title": "Boshqa savol bormi?",
  "help.contact.body": "Telegram bo'ti orqali yozing — biz bir kun ichida javob beramiz. Yoki email yuboring.",
  "help.contact.telegram": "Telegram",
  "help.contact.email": "Email",
  "help.contact.dashboard": "Boshqaruvga o'tish →",
  "editor.preview.title": "Jonli ko'rinish",
  "editor.preview.open_new": "Yangi oynada ↗",
  "editor.preview.empty": "Saqlagandan so'ng ko'rinadi",
  "editor.notfound.title": "Topilmadi",
  "editor.notfound.body": "Bu taklifnoma mavjud emas yoki sizga tegishli emas.",
  "editor.notfound.back": "← Boshqaruv paneliga qaytish",
  "editor.no_template.title": "Shablon tanlanmagan",
  "editor.no_template.body": "Iltimos, avval shablon galereyasidan birini tanlang.",
  "editor.no_template.back": "← Galereyaga qaytish",

  // ── Login ────────────────────────────────────────────────────────────
  "login.title": "Kirish",
  "login.label.email": "Email",
  "login.placeholder.email": "siz@email.uz",
  "login.placeholder.code": "123456",
  "login.send_code": "Kod yuborish",
  "login.sending": "Yuborilmoqda…",
  "login.code_sent": "{target} ga 6 xonali kod yubordik.",
  "login.verify": "Tasdiqlash",
  "login.verifying": "Tekshirilmoqda…",
  "login.back": "Orqaga",
  "login.error.send": "Yuborib bo'lmadi",
  "login.error.code": "Kod noto'g'ri",

  // Sign in with Google — Google's button itself is rendered by the GIS
  // SDK with a built-in label; these keys are for the surrounding UI.
  "auth.google.button": "Google orqali kirish",
  "auth.google.divider": "yoki",
  "auth.google.error.unverified": "Bu Google hisobining email manzili tasdiqlanmagan.",
  "auth.google.error.failed": "Google orqali kirish muvaffaqiyatsiz tugadi. Qayta urinib ko'ring.",
  "auth.google.error.disabled": "Google orqali kirish hozircha o'chirilgan.",

  // Sign in with Telegram — Telegram OIDC + PKCE. Button is rendered by
  // us (no official drop-in for the OIDC flow), so the label is i18n'd.
  "auth.telegram.button": "Telegram bilan kirish",
  "auth.telegram.signing_in": "Telegram orqali tekshirilmoqda…",
  "auth.telegram.error.title": "Kirishda xatolik",
  "auth.telegram.error.back_to_login": "Kirish sahifasiga qaytish",
  "auth.telegram.error.start": "Telegramga ulanib bo'lmadi. Qayta urinib ko'ring.",
  "auth.telegram.error.from_telegram": "Telegram javob qaytardi: {detail}",
  "auth.telegram.error.missing_code": "Telegramdan kod kelmadi. Boshidan urinib ko'ring.",
  "auth.telegram.error.no_state": "Kirish sessiyasi topilmadi. Boshidan urinib ko'ring.",
  "auth.telegram.error.stale": "Kirish sessiyasi muddati o'tib ketdi. Qaytadan urinib ko'ring.",
  "auth.telegram.error.state_mismatch": "Xavfsizlik tekshiruvi o'tmadi. Qaytadan urinib ko'ring.",
  "auth.telegram.error.exchange": "Telegram tokenini almashtirib bo'lmadi. Qayta urinib ko'ring.",
  "auth.telegram.error.disabled": "Telegram orqali kirish hozircha o'chirilgan.",

  "auth.verify.success": "Tasdiqlandi",

  // ── 404 ──────────────────────────────────────────────────────────────
  "notfound.eyebrow": "Sahifa topilmadi",
  "notfound.title": "Sahifa topilmadi",
  "notfound.body": "Bu sahifa hali yaratilmagan yoki o'chirilgan. Bosh sahifaga qayting yoki shablonlar bo'limini ko'ring.",
  "notfound.home": "Bosh sahifaga qaytish",
  "notfound.gallery": "Shablonlarni ko'rish",

  // ── Guest page (error/loading shell only) ────────────────────────────
  "guest.loading": "Yuklanmoqda…",
  "guest.notfound.title": "Taklifnoma topilmadi",
  "guest.notfound.body": "Bu havola eskirgan yoki noto'g'ri.",
  "guest.error.title": "Xato yuz berdi",
  "guest.cta.respond": "Javob bering →",
  "guest.cta.coming": "✓ Albatta kelaman",
  "guest.cta.declined": "Kelolmayman",
  "guest.music.play_aria": "Play music",
  "guest.music.pause_aria": "Pause music",
  "guest.music.now_playing": "Now playing",
  "guest.music.tap_to_play": "Tap to play",

  // ── PhotoUploader ────────────────────────────────────────────────────
  "photo.count": "{n} / {max} rasm",
  "photo.add": "+ Rasm qo'shish",
  "photo.add_aria": "Rasm qo'shish",
  "photo.pick_aria": "Rasm tanlash",
  "photo.zone.title": "Rasm tashlang yoki tanlang",
  "photo.zone.caption": "JPG, PNG, WEBP — 10MB gacha",
  "photo.zone.slots": "{n} ta joy qoldi",
  "photo.zone.aria": "Rasm tashlang yoki tanlash uchun bosing",
  "photo.alt": "Rasm {n}",
  "photo.delete_aria": "Rasmni {n} o'chirish",
  "photo.uploading_alt": "Yuklanmoqda",
  "photo.uploading_aria": "Yuklanmoqda",
  "photo.error_fallback": "Xatolik",
  "photo.retry": "Qayta",
  "photo.retry_aria": "Qayta urinish",
  "photo.cancel_aria": "Bekor qilish",
  "photo.error.mime": "\"{name}\" — faqat JPG, PNG yoki WEBP qabul qilinadi",
  "photo.error.size": "\"{name}\" — 10MB dan katta, yuklab bo'lmaydi",
  "photo.error.max": "Maksimal {max} ta rasm yuklash mumkin",
  "photo.error.network": "Tarmoq xatosi",

  // ── MusicSelector ────────────────────────────────────────────────────
  "music.section_label": "Musiqa",
  "music.none.subtitle": "Tinch ochiladi",
  "music.loading": "Yuklanmoqda…",
  "music.fallback_notice": "Katalog vaqtincha mavjud emas — namunaviy ro'yxat ko'rsatilmoqda.",
  "music.preview.play_aria": "Play preview",
  "music.preview.pause_aria": "Pause preview",

  // ── RSVP section extras ──────────────────────────────────────────────
  "sections.rsvp.thanks": "Rahmat! Javobingiz qabul qilindi",
  "sections.rsvp.err": "Yuborib bo'lmadi — qaytadan urinib ko'ring",
  "sections.rsvp.your_name": "Sizning ismingiz",
  "sections.rsvp.deadline": "Iltimos, {day}-{month}gacha javob bering.",
  "sections.rsvp.thanks_short": "Rahmat!",
  "sections.rsvp.guest_count": "Mehmon soni:",
  "sections.rsvp.regret_title": "Afsus...",
  "sections.rsvp.regret_body": "Sizni qo'msab eslaymiz. Eng yaxshi tilaklar uchun rahmat.",
  "sections.rsvp.month.1": "yan",
  "sections.rsvp.month.2": "fev",
  "sections.rsvp.month.3": "mart",
  "sections.rsvp.month.4": "apr",
  "sections.rsvp.month.5": "may",
  "sections.rsvp.month.6": "iyun",
  "sections.rsvp.month.7": "iyul",
  "sections.rsvp.month.8": "avg",
  "sections.rsvp.month.9": "sen",
  "sections.rsvp.month.10": "okt",
  "sections.rsvp.month.11": "noy",
  "sections.rsvp.month.12": "dek",
  "sections.ics.suffix.wedding": " — Nikoh",
  "sections.ics.suffix.birthday": " — Bayram",
  "sections.ics.description.wedding": "Sizni to'yga kutamiz",
  "sections.ics.description.default": "Sizni tantanaga kutamiz",

  // ── Footer ────────────────────────────────────────────────────────────
  "footer.tagline": "O'zbekistondagi eng chiroyli raqamli taklifnomalar. Har bir muhim daqiqa uchun.",
  "footer.col.discover": "Kashf eting",
  "footer.col.discover.all": "Barcha shablonlar",
  "footer.col.discover.wedding": "To'y taklifnomalari",
  "footer.col.discover.nikoh": "Nikoh to'yi",
  "footer.col.discover.birthday": "Tug'ilgan kun",
  "footer.col.discover.beshik": "Beshik to'y",
  "footer.col.company": "Kompaniya",
  "footer.col.company.about": "Biz haqimizda",
  "footer.col.company.designers": "Dizaynerlar",
  "footer.col.company.privacy": "Maxfiylik",
  "footer.col.company.terms": "Shartnoma",
  "footer.col.company.contact": "Aloqa",
  "footer.col.payment": "To'lov",
  "footer.copyright": "© 2026 Taklifla.uz",
  "footer.made": "Toshkentda mehr bilan tayyorlandi · ✦",
  "support.aria": "Yordam",
  "support.note": "Muammo bo'lsa, Telegram orqali yozing:",
  "inapp.aria": "Brauzer ogohlantirishi",
  "inapp.body": "Ba'zi funksiyalar bu yerda to'liq ishlamasligi mumkin. Xohlasangiz, saytni odatdagi brauzeringizda oching.",
  "inapp.open_browser": "Brauzerda ochish ↗",
  "inapp.copy": "Havolani nusxa olish",
  "inapp.copied": "Nusxa olindi ✓",
  "inapp.copy_fallback": "Havolani belgilang va nusxa oling:",
  "inapp.ios_hint": "iOS: pastdagi ⋯ tugmasini bosib \"Browser'da ochish\" tanlang.",
  "inapp.dismiss": "Yopish",
  "auth.telegram.hint": "Telegram'da tasdiqlagandan so'ng saytga qaytasiz. Agar saytga qaytmasangiz, ushbu sahifani qayta yangilang yoki pastdagi email orqali kiring.",
  "auth.inapp.handoff_hint": "Telegram'ni bossangiz, sizni odatdagi brauzerga olib chiqamiz.",
  "auth.inapp.google_resume": "Quyidagi Google tugmasini bosib davom eting.",
  "editor.lock.identity.pre_publish": "Diqqat: ism va sana nashr qilingandan keyin 48 soat ichida tahrirlash mumkin. Keyin qulflanadi — bitta to'lov bilan boshqa juftlik uchun foydalanib bo'lmaydi.",
  "editor.lock.identity.grace": "Ism va sana hali tahrirlanadi — yana {remaining} keyin qulflanadi.",
  "editor.lock.identity.locked": "Ism va sana qulflangan: nashrdan 48 soat o'tdi. Joy, jadval, musiqa, eslatma kabi maydonlar hali ham tahrirlanadi. Agar haqiqatan ham o'zgartirish kerak bo'lsa, qo'llab-quvvatlash xizmatiga yozing.",
  "editor.lock.slug.pre_publish": "Diqqat: nashrdan keyin havolani faqat 3 marta va 7 kun ichida o'zgartirish mumkin. Keyin URL muzlatiladi.",
  "editor.lock.slug.remaining": "Yana {n} marta havolani o'zgartira olasiz (nashrdan 7 kun ichida).",
  "editor.lock.slug.frozen": "Havola muzlatildi: 3 ta o'zgartirish ishlatilgan yoki nashrdan 7 kun o'tgan. Bu manzilni o'zgartirib bo'lmaydi.",
  "editor.error.identity_locked": "Ism va sana 48 soatdan keyin qulflangan. Bu maydonlarni o'zgartirib bo'lmaydi.",
  "editor.error.slug_frozen": "Havola muzlatildi. URL'ni o'zgartirib bo'lmaydi.",
  "auth.already_signed_in": "Siz allaqachon kirgansiz.",
  "auth.go_to_dashboard": "Dashboard'ga o'tish",

  // ── variant.w01 (Asal — Editorial) ─────────────────────────────────────
  "variant.w01.hero.eyebrow": "NIKOH MAROSIMI",
  "variant.w01.hero.and": "and",
  "variant.w01.hero.body": "\"Sizni hayotimizdagi eng muhim kunni biz bilan baham ko'rishga taklif qilamiz.\"",
  "variant.w01.hero.love_tag": "from us, with love",
  "variant.w01.hero.caption_label": "ROYAL PALACE",
  "variant.w01.story.eyebrow": "our story",
  "variant.w01.story.title": "Bizning hikoyamiz",
  "variant.w01.story.body": "Olti yil oldin universitet kutubxonasida tasodifan tanishdik. O'sha kuni qanday qilib uydan kech qaytishimiz haqida o'zaro hazillashgandik. Bugun esa, butun umrimizni birga o'tkazish niyati bilan, sizni bizning eng baxtli kunimizga taklif qilamiz.",
  "variant.w01.quote.text": "\"Ishq ahli ko'p, lekin chin oshiqlar oz.\"",
  "variant.w01.quote.author": "— ALISHER NAVOIY",
  "variant.w01.bridal.eyebrow": "BRIDAL PARTY",
  "variant.w01.bridal.title": "Yonimizda turuvchilar",
  "variant.w01.bridal.groom_label": "Kuyov tomondan",
  "variant.w01.bridal.groom_list": "Sardor (uka) · Bobur · Akmal",
  "variant.w01.bridal.bride_label": "Kelin tomondan",
  "variant.w01.bridal.bride_list": "Madina (singil) · Nilufar · Sevara",
  "variant.w01.schedule.0.time": "16:30",
  "variant.w01.schedule.0.event": "Mehmonlarni kutib olish",
  "variant.w01.schedule.1.time": "17:00",
  "variant.w01.schedule.1.event": "Nikoh marosimi",
  "variant.w01.schedule.2.time": "18:00",
  "variant.w01.schedule.2.event": "Tantanali kechki ovqat",
  "variant.w01.schedule.3.time": "20:00",
  "variant.w01.schedule.3.event": "Raqs va musiqa",
  "variant.w01.schedule.4.time": "23:00",
  "variant.w01.schedule.4.event": "Ot ot",
  "variant.w01.map.address": "\"Royal Palace\" to'yxonasi · Yunusobod 12-mavze",

  // ── variant.w04 (Tilla — Magazine) ─────────────────────────────────────
  "variant.w04.cover.lead": "The Wedding of",
  "variant.w04.cover.featured": "FEATURED",
  "variant.w04.cover.exclusive": "EXCLUSIVE EDITION",
  "variant.w04.cover.edition": "EDITION 01 / 99",
  "variant.w04.cover.vol": "VOL. I · NO. 1",
  "variant.w04.cover.meta_date": "SANA",
  "variant.w04.cover.meta_time": "VAQT",
  "variant.w04.cover.meta_venue": "JOY",
  "variant.w04.spread.feature_no": "FEATURE · 04",
  "variant.w04.spread.title": "The Spread",
  "variant.w04.spread.pages": "PG. 12—15",
  "variant.w04.spread.shot1": "SHOT 01",
  "variant.w04.quote.text": "Sevgi — bu ikki qalbni bir maqsad sari yo'naltirgan kuch.",
  "variant.w04.timeline.eyebrow": "OUR JOURNEY",
  "variant.w04.timeline.title": "Sevgi xronikasi",
  "variant.w04.timeline.chapter": "CHAPTER",
  "variant.w04.timeline.0.event": "Tanishuv",
  "variant.w04.timeline.0.sub": "Universitet kutubxonasida tasodif",
  "variant.w04.timeline.1.event": "Birinchi sayohat",
  "variant.w04.timeline.1.sub": "Samarqandga birga sayohat",
  "variant.w04.timeline.2.event": "Taklif",
  "variant.w04.timeline.2.sub": "Charvoq sohilida \"ha\"",
  "variant.w04.timeline.3.event": "Nikoh",
  "variant.w04.timeline.3.sub": "Bugungi muborak kun",
  "variant.w04.schedule.0.time": "17:00",
  "variant.w04.schedule.0.event": "Mehmonlar kutib olish",
  "variant.w04.schedule.1.time": "18:00",
  "variant.w04.schedule.1.event": "Nikoh marosimi",
  "variant.w04.schedule.2.time": "19:00",
  "variant.w04.schedule.2.event": "Galaxy Hall · Kechki ovqat",
  "variant.w04.schedule.3.time": "21:00",
  "variant.w04.schedule.3.event": "Tantanali raqslar",
  "variant.w04.schedule.4.time": "23:00",
  "variant.w04.schedule.4.event": "Otashin shou",
  "variant.w04.dress.eyebrow": "DRESS CODE",
  "variant.w04.dress.title": "Black Tie & Gold",
  "variant.w04.dress.blurb": "Kechki marosim uchun rasmiy libos. Erkaklar uchun smoking yoki to'q kostyum, ayollar uchun uzun ko'ylak.",
  "variant.w04.dress.preferred_for": "PREFERRED ATTIRE FOR {name}",
  "variant.w04.dress.swatch.0.name": "Black",
  "variant.w04.dress.swatch.0.role": "Smoking",
  "variant.w04.dress.swatch.1.name": "Gold",
  "variant.w04.dress.swatch.1.role": "Aksessuar",
  "variant.w04.dress.swatch.2.name": "Cream",
  "variant.w04.dress.swatch.2.role": "Ko'ylak",
  "variant.w04.dress.swatch.3.name": "Burgundy",
  "variant.w04.dress.swatch.3.role": "Galstuk",
  "variant.w04.map.address": "\"Galaxy Hall\" · Mirzo Ulug'bek 8",
  "variant.w04.signoff": "Hurmat bilan, {first} & {second}",

  // ── variant.w03 (Bahor — PhotoLed) ─────────────────────────────────────
  "variant.w03.hero.save_the_date": "save the date",
  "variant.w03.scrap.title": "Hayot tarjimaiholimizning yangi bobi",
  "variant.w03.scrap.lede": "Bu kunni siz bilan birga nishonlash biz uchun katta sharaf bo'ladi.",
  "variant.w03.story.eyebrow": "our story",
  "variant.w03.story.title": "Bizni biriktirgan kun",
  "variant.w03.story.body": "Bu yo'l oson bo'lmadi, lekin har bir qadamda bir-birimizni qo'llab-quvvatlab kelganmiz. Endi esa, sizni eng go'zal kunimizga taklif qilishdan baxtiyormiz.",
  "variant.w03.quote.text": "\"Buxoro — Buyuk Ipak yo'lining marvaridi.\"",
  "variant.w03.quote.eyebrow": "BUKHARA · 21.05.2026",
  "variant.w03.stamp.line1": "BUKHARA",
  "variant.w03.stamp.line2": "2026",
  "variant.w03.schedule.0.time": "16:00",
  "variant.w03.schedule.0.event": "Photoshoot",
  "variant.w03.schedule.1.time": "17:00",
  "variant.w03.schedule.1.event": "Nikoh",
  "variant.w03.schedule.2.time": "18:30",
  "variant.w03.schedule.2.event": "Banket",
  "variant.w03.schedule.3.time": "21:00",
  "variant.w03.schedule.3.event": "Raqslar",
  "variant.w03.map.address": "\"Bahor\" bog'i",

  // ── variant.n01 (Nikoh Royal — Ceremonial) ─────────────────────────────
  "variant.n01.hero.eyebrow": "BISMILLAHIR ROHMANIR ROHIM",
  "variant.n01.detail.0.label": "Marosim joyi",
  "variant.n01.detail.1.label": "Mahallamiz",
  "variant.n01.quran.eyebrow": "QUR'ON KARIM",
  "variant.n01.quran.surah": "Ar-Rum surasi · 21-oyat",
  "variant.n01.quran.uzbek": "\"Va O'zining oyatlaridan biri shulki, sizlar uchun o'zingizdan jufti halollar yaratdi, ularga moyil bo'lasizlar deb. Va orangizda muhabbat va rahmatni paydo qildi.\"",
  "variant.n01.schedule.0.time": "10:00",
  "variant.n01.schedule.0.event": "Nikoh o'qilishi",
  "variant.n01.schedule.1.time": "12:00",
  "variant.n01.schedule.1.event": "Tushlik",
  "variant.n01.schedule.2.time": "15:00",
  "variant.n01.schedule.2.event": "Maslahat",
  "variant.n01.schedule.3.time": "17:00",
  "variant.n01.schedule.3.event": "Yakuniy duo",
  "variant.n01.map.address": "Mahalla guzari",
  "variant.n01.rsvp.label": "Marosimga taklifimiz.",
  "variant.n01.blessing.translit": "rabbi zidnii ilman",

  // ── variant.w05 (Oqshom — Minimal) ─────────────────────────────────────
  "variant.w05.meta.label": "OQSHOM  ·  NO. 05",
  "variant.w05.meta.year": "MMXXVI",
  "variant.w05.meta.tagline": "the walled city",
  "variant.w05.meta.country": "UZBEKISTAN",
  "variant.w05.cta.save": "SAVE THE DATE  ·  .ICS",
  "variant.w05.cta.rsvp": "JAVOB BERING",
  "variant.w05.invite.mark": "¶ I",
  "variant.w05.invite.copy": "Hayotimizdagi eng go'zal kunni siz bilan baham ko'rishni istaymiz.",
  "variant.w05.schedule.eyebrow": "¶ II  ·  DASTUR",
  "variant.w05.schedule.title_1": "Kun",
  "variant.w05.schedule.title_2": "tartibi.",
  "variant.w05.schedule.0.num": "01",
  "variant.w05.schedule.0.time": "17:00",
  "variant.w05.schedule.0.event": "Nikoh marosimi",
  "variant.w05.schedule.1.num": "02",
  "variant.w05.schedule.1.time": "18:00",
  "variant.w05.schedule.1.event": "Kechki ovqat",
  "variant.w05.schedule.2.num": "03",
  "variant.w05.schedule.2.time": "19:30",
  "variant.w05.schedule.2.event": "Tabriklar",
  "variant.w05.schedule.3.num": "04",
  "variant.w05.schedule.3.time": "20:00",
  "variant.w05.schedule.3.event": "Raqs",
  "variant.w05.colophon.title": "COLOPHON",
  "variant.w05.colophon.set_label": "SET",
  "variant.w05.colophon.set_value": "BODONI MODA",
  "variant.w05.colophon.accent_label": "ACCENT",
  "variant.w05.colophon.accent_value": "SAGE 7A8268",
  "variant.w05.colophon.paper_label": "PAPER",
  "variant.w05.colophon.paper_value": "CREAM F5EFE6",
  "variant.w05.colophon.place_label": "PLACE",
  "variant.w05.aria.date": "Sana {date}",

  // ── variant.b02 (Confetti — Celebration) ───────────────────────────────
  "variant.b02.hero.callout": "happy birthday",
  "variant.b02.hero.yosh": "yosh bo'ladi!",
  "variant.b02.cta": "🎉 Bayramga kelaman!",
  "variant.b02.memories.eyebrow": "memories",
  "variant.b02.memories.title": "Eng yorqin daqiqalar",
  "variant.b02.memories.caption.0": "birthday boy!",
  "variant.b02.memories.caption.1": "with friends",
  "variant.b02.memories.caption.2": "cake time",
  "variant.b02.cake.eyebrow": "make a wish",
  "variant.b02.cake.title": "Diyor 7 yoshda!",
  "variant.b02.wishlist.eyebrow": "wishlist",
  "variant.b02.wishlist.title": "Sovg'a g'oyalari",
  "variant.b02.wishlist.0.label": "Lego Star Wars",
  "variant.b02.wishlist.0.price": "220 000 so'm",
  "variant.b02.wishlist.1.label": "Velosiped",
  "variant.b02.wishlist.1.price": "450 000 so'm",
  "variant.b02.wishlist.2.label": "Kitoblar to'plami",
  "variant.b02.wishlist.2.price": "85 000 so'm",
  "variant.b02.wishlist.3.label": "Ranglar to'plami",
  "variant.b02.wishlist.3.price": "45 000 so'm",
  "variant.b02.wishlist.claim": "CLAIM",
  "variant.b02.wishlist.claimed": "✓ CLAIMED!",
  "variant.b02.rsvp.label": "Bayramga kutamiz!",

  // ── variant.bs01 (Beshik — Newborn) ────────────────────────────────────
  "variant.bs01.hero.welcome_stamp": "WELCOME, AMIR",
  "variant.bs01.hero.script": "welcome little one",
  "variant.bs01.hero.alla": "\"Alla, alla, jonim bolam, qulagim, alla…\"",
  "variant.bs01.hero.body": "Oilamizga yangi a'zo qo'shildi. Beshik to'yi marosimimizga sizni taklif qilamiz.",
  "variant.bs01.hero.datebox_eyebrow": "BESHIK TO'YI",
  "variant.bs01.story.eyebrow": "our blessing",
  "variant.bs01.story.title": "Yangi hayot, yangi quvonch",
  "variant.bs01.story.body": "Oilamizga sevimli farzandimizning kelishi bilan, sizni ham bu quvonchga sherik bo'lishga taklif qilamiz. Beshik to'yi an'analarimizning eng go'zal qismidir.",
  "variant.bs01.triptych.eyebrow": "tiny moments",
  "variant.bs01.triptych.title": "Birinchi kunlar",
  "variant.bs01.triptych.caption.0": "first day",
  "variant.bs01.triptych.caption.1": "month one",
  "variant.bs01.triptych.caption.2": "month two",
  "variant.bs01.rsvp.label": "Bayramda sizni kutamiz.",

  // ── variant.c01 (Forum — Agenda) ───────────────────────────────────────
  "variant.c01.hero.vol": "VOL.01 — ANNUAL EDITION",
  "variant.c01.hero.label": "// 01 — INVITATION",
  "variant.c01.hero.venue_suffix": "HYATT REGENCY",
  "variant.c01.hero.stat.date": "DATE",
  "variant.c01.hero.stat.time": "TIME",
  "variant.c01.hero.stat.venue": "VENUE",
  "variant.c01.hero.stat.dress": "DRESS",
  "variant.c01.hero.stat.dress_value": "BLACK TIE",
  "variant.c01.ticker.0": "ANNUAL CORPORATE GALA",
  "variant.c01.ticker.1": "TASHKENT",
  "variant.c01.ticker.2": "HYATT REGENCY",
  "variant.c01.ticker.3": "BLACK TIE",
  "variant.c01.ticker.4": "RSVP REQUIRED",
  "variant.c01.ticker.5": "VOL.01",
  "variant.c01.ticker.6": "PREMIUM TIER",
  "variant.c01.agenda.label": "AGENDA",
  "variant.c01.agenda.head_time": "TIME",
  "variant.c01.agenda.head_session": "SESSION",
  "variant.c01.agenda.head_duration": "DURATION",
  "variant.c01.agenda.min_suffix": "MIN",
  "variant.c01.agenda.details": "+ details",
  "variant.c01.agenda.0.title": "Welcome reception",
  "variant.c01.agenda.0.sub": "Foyer · Light refreshments",
  "variant.c01.agenda.0.detail": "Cocktails and canapés in the Hyatt Regency foyer. Press lounge available adjacent to the main hall.",
  "variant.c01.agenda.1.title": "Opening keynote",
  "variant.c01.agenda.1.sub": "Main hall · CEO address",
  "variant.c01.agenda.1.detail": "Year in review and strategic outlook. Live captioning provided. Photography permitted from designated areas only.",
  "variant.c01.agenda.2.title": "Awards ceremony",
  "variant.c01.agenda.2.sub": "Recognition of outstanding work",
  "variant.c01.agenda.2.detail": "Presentation of annual awards across leadership, craft, and team excellence categories.",
  "variant.c01.agenda.3.title": "Dinner",
  "variant.c01.agenda.3.sub": "Three-course menu",
  "variant.c01.agenda.3.detail": "Curated three-course menu by the Hyatt culinary team. Dietary preferences confirmed at RSVP.",
  "variant.c01.agenda.4.title": "Live band",
  "variant.c01.agenda.4.sub": "Until late",
  "variant.c01.agenda.4.detail": "Live performance and dancing. Late carriages can be arranged with the concierge desk.",
  "variant.c01.speakers.label": "SPEAKERS",
  "variant.c01.speakers.0.role": "CEO",
  "variant.c01.speakers.1.role": "CMO",
  "variant.c01.speakers.2.role": "CTO",
  "variant.c01.dress.label": "DRESS CODE",
  "variant.c01.dress.title": "BLACK TIE",
  "variant.c01.dress.body": "Strict black tie — formal evening wear required. Tuxedo or dinner jacket with bow tie for gentlemen; floor-length evening gown or cocktail dress for ladies. No exceptions at the door.",
  "variant.c01.dress.palette_label": "PERMITTED PALETTE",
  "variant.c01.dress.swatch.0": "BLACK",
  "variant.c01.dress.swatch.1": "WHITE",
  "variant.c01.dress.swatch.2": "IVORY",
  "variant.c01.dress.swatch.3": "GOLD ACCENT",
  "variant.c01.venue.label": "VENUE",
  "variant.c01.rsvp.label": "RSVP",
  "variant.c01.rsvp.confirm": "Confirm attendance.",
  "variant.c01.share.label": "SHARE",
  "variant.c01.tier": "FORUM PREMIUM",
  "variant.c01.map.address": "Hyatt Regency · Conference Hall A",

  // ── variant.m01 (Tinch — Memorial) ─────────────────────────────────────
  "variant.m01.mourning.translit": "Innaa lillaahi va innaa ilayhi rojiun",
  "variant.m01.hero.eyebrow": "MARHUMNI XOTIRLAB",
  "variant.m01.hero.body": "Aziz otamiz, bobomiz va do'stimiz xotirasini yod etib, sizni xotira marosimiga taklif qilamiz. Iltimos, oilamiz bilan birga ibodat qilishga keling.",
  "variant.m01.marosim.label": "MAROSIM",
  "variant.m01.recitation.translit": "\"Innaa lillaahi va innaa ilayhi rojiun\"",
  "variant.m01.recitation.meaning": "Albatta, biz Allohnikimiz va albatta, biz Unga qaytguvchimiz.",
  "variant.m01.dua.label": "DUO VA YORDAM",
  "variant.m01.dua.line": "Marhumning xotirasiga duo o'qing va oilaga ma'naviy yordam bering.",
  "variant.m01.dua.sub": "Gullar o'rniga — bir Fotiha, bir duo. Oila uchun siz keltiradigan eng qimmatli sovg'a shu.",
  "variant.m01.ledger.label": "XOTIRA DAFTARI",
  "variant.m01.ledger.title": "Bir xotira qoldiring",
  "variant.m01.ledger.thanks": "Xotirangiz uchun rahmat.",
  "variant.m01.ledger.name_placeholder": "Ismingiz",
  "variant.m01.ledger.line_placeholder": "Bir og'iz xotira yoki duo…",
  "variant.m01.ledger.submit": "QOLDIRISH",
  "variant.m01.map.address": "Marhum xonadoni",
  "variant.m01.photo_aria": "{names} fotosurati",

  // ── variant.w06 (Sumalak — Botanical) ──────────────────────────────────
  "variant.w06.hero.tagline": "Bahor — yangilanish, sumalak — muhabbat. Bizning to'yimizga marhamat.",
  "variant.w06.story.eyebrow": "muhabbat hikoyasi",
  "variant.w06.story.title": "Registan oldida boshlangan bahor",
  "variant.w06.story.body": "Bizning yo'limiz Samarqandda, Registan maydonining oltin nuri ostida kesishdi. Gulnora Sher-Dor madrasasining gulli gumbazlariga tikilib turgan kuni, Jamshid uning yonida o'sha qadim manzaraga birinchi marta boshqa ko'z bilan qaradi. Bibi-Xonim atrofida hovli bog'larida sayr qilgan kunlar, Siyob bozoridagi ilk patir va shirinliklar, va Navruz arafasida birga pishirgan sumalakimiz — barchasi bizni shu kunga olib keldi. Endi bahor qaytdi, daraxtlar gulladi, va biz sizni o'z to'yimizga, o'zimiz sevgan shaharda, marhamat qilamiz.",
  "variant.w06.navruz.eyebrow": "NAVRUZ · BAHOR AN'ANASI",
  "variant.w06.navruz.title": "Sumalak — bahorning shirin va'dasi",
  "variant.w06.navruz.body": "Navruz arafasida ayollar tunni qozon atrofida o'tkazib, undirgan bug'doy maysasidan sumalak pishiradilar — toshqolaq bilan to'qson olti soat davom etgan bahor ibodati. Yaxshi niyatlar qaynab, oltin tusga aylanadi: barakat, sog'liq, va yangi hayotning birinchi shirinligi.",
  "variant.w06.navruz.proverb": "\"Sumalak hosil bo'lsin, baxting ziyod bo'lsin.\"",
  "variant.w06.navruz.badge_0_label": "Bug'doy maysasi",
  "variant.w06.navruz.badge_0_sub": "ko'klam",
  "variant.w06.navruz.badge_1_label": "Anor",
  "variant.w06.navruz.badge_1_sub": "ziyo va baraka",
  "variant.w06.navruz.badge_2_label": "Za'faron",
  "variant.w06.navruz.badge_2_sub": "quyosh nuri",
  "variant.w06.schedule.0.event": "Navruz osh — sumalak ulashish",
  "variant.w06.schedule.1.event": "Nikoh marosimi",
  "variant.w06.schedule.2.event": "Tantanali tushlik",
  "variant.w06.schedule.3.event": "Photoshoot Registan oldida",
  "variant.w06.schedule.4.event": "Banket va musiqa",
  "variant.w06.schedule.5.event": "Olov atrofida raqs",
  "variant.w06.map.address": "Samarqand · Registan maydoni · 'Karavan-Saray' to'yxonasi",
  "variant.w06.rsvp.label": "Bahorga marhamat — to'yimizga taklifimiz",

  // ── variant.w07 (Marvarid — Seaside) ──────────────────────────────────
  "variant.w07.hero.cta": "JAVOB BERISH",
  "variant.w07.story.eyebrow": "bizning hikoyamiz",
  "variant.w07.story.title": "Charvakda boshlangan hikoya",
  "variant.w07.story.body": "Bizning birinchi uchrashuvimiz Charvak suv omborida — yoz oqshomi, qayiqda. Lola horizontga termulgan paytda, Jasur unga marvarid sirg'alarini sovg'a qildi. Oradan ikki yoz o'tdi: choyxonalar, sohil sayrlari va minglab kunbotarlar. Endi siz bilan birga, o'sha suvning yonida, abadiy 'ha' deyish vaqti.",
  "variant.w07.tide.title": "Charvak suvi jadvali",
  "variant.w07.tide.subtitle": "Qayiq paradini quyoshli soatlarda boshlaymiz — marosim sahniga suv yuzasi qo'shilsin.",
  "variant.w07.tide.0.label": "Quyosh chiqishi",
  "variant.w07.tide.1.label": "Yuksak suv",
  "variant.w07.tide.2.label": "Qayiq paradi",
  "variant.w07.tide.3.label": "Quyosh botishi",
  "variant.w07.schedule.0.event": "Mehmonlarni kutib olish · sohil",
  "variant.w07.schedule.1.event": "Nikoh marosimi · suv ustida",
  "variant.w07.schedule.2.event": "Tushlik banketi",
  "variant.w07.schedule.3.event": "Qayiqda sayohat",
  "variant.w07.schedule.4.event": "Yulduzli banket",
  "variant.w07.schedule.5.event": "Olov shou",
  "variant.w07.map.address": "Charvak · 'Royal Marina' to'yxonasi · suv yuzasida",

  // ── variant.y01 (Yubiley — Jubilee) ───────────────────────────────────
  "variant.y01.story.eyebrow": "bizning hikoyamiz",
  "variant.y01.story.title": "25 yillik uy",
  "variant.y01.story.body": "Yigirma besh yil burun ikki kishi bir umrlik yo'lga chiqqan edi. Madina va Tursun — uchta farzand kattaytirdi, birinchi nabira kulgisini eshitdi, qadrdon do'stlar bilan dasturxon yondi va sukut chog'larida ham bir-birining qo'lini qo'yib yubormadi. Birgalikda qarish — bu ham eng katta sovg'a, ham eng katta mehnat. Bugun shu yo'lning chorak asrini qadrlaymiz va siz aziz yaqinlarimiz bilan birga nishonlamoqchimiz.",
  "variant.y01.timeline.title": "Yo'limizning bekatlari",
  "variant.y01.timeline.0.title": "Nikoh",
  "variant.y01.timeline.0.body": "Madina va Tursunning to'yi. Bahor edi, oilalar bir-birini birinchi marta yaqindan tanidi.",
  "variant.y01.timeline.1.title": "Birinchi farzand",
  "variant.y01.timeline.1.body": "Oilada birinchi qadamlar — to'ng'ich qizimiz dunyoga keldi. Uy bolalar kulgisiga to'ldi.",
  "variant.y01.timeline.2.title": "O'z xonadonimiz",
  "variant.y01.timeline.2.body": "Yetti yillik birgalikdagi mehnatdan keyin, Toshkentda birinchi o'z uyimizning kalitlari qo'limizga tegdi.",
  "variant.y01.timeline.3.title": "Birinchi nabira",
  "variant.y01.timeline.3.body": "Bobo va buvi unvonlari. Hayotimizning eng kutilgan sovg'asi — birinchi nevaramiz.",
  "variant.y01.timeline.4.title": "Kumush to'y",
  "variant.y01.timeline.4.body": "Yigirma yillik birgalik. Oila davrasida yana bir bor 'ha' dedik — bu safar to'liq farzandlar bilan.",
  "variant.y01.timeline.5.title": "25 yillik yubiley",
  "variant.y01.timeline.5.body": "Chorak asrlik birgalik. Bugun siz bilan bu sanani nishonlashga taklif qilamiz.",
  "variant.y01.schedule.0.event": "Mehmonlarni kutib olish",
  "variant.y01.schedule.1.event": "Sharafli so'zlar · farzandlardan",
  "variant.y01.schedule.2.event": "Banket",
  "variant.y01.schedule.3.event": "Birinchi raqs · 25 yil keyin",
  "variant.y01.schedule.4.event": "Tabriklar va sovg'alar",
  "variant.y01.map.address": "Toshkent · 'Heritage Hall' yubiley zali",

  // ── variant.f01 (Fotixa — Engagement) ─────────────────────────────────
  "variant.f01.hero.eyebrow": "FOTIXA TO'YI",
  "variant.f01.story.eyebrow": "oilamiz",
  "variant.f01.story.title": "Ikki oila bir dasturxon atrofida",
  "variant.f01.story.body": "Bugun ikki oila bir dasturxon atrofida birlashdi. Otalar — Rustam aka va Bahodir aka — qo'l berib so'rashib, hayot yo'lining yangi sahifasini ochishdi. Onalar esa an'anaviy non, shirinlik va qo'lda tikilgan ro'molchalarni almashishdi — shu kichik sovg'alar yaqinlik va hurmatning belgisi. Aziza va Sardor o'z 'ha'larini aytishdi; biz, ikkala oila, sizni shu muqaddas daqiqalarga shohid bo'lishga taklif qilamiz.",
  "variant.f01.family.eyebrow": "IKKI OILA · BIR DARAXT",
  "variant.f01.family.title": "Oilamiz daraxti",
  "variant.f01.family.intro": "Ikki ildiz bir tanaga aylanib, yangi shox-shabbalarni keltiradi. Aziza va Sardorning bir-biriga aytgan \"ha\"si shu daraxtning birinchi guli.",
  "variant.f01.family.groom_label": "Kuyov tomon",
  "variant.f01.family.bride_label": "Kelin tomon",
  "variant.f01.family.groom.0.role": "Otasi",
  "variant.f01.family.groom.0.name": "Rustam aka",
  "variant.f01.family.groom.1.role": "Onasi",
  "variant.f01.family.groom.1.name": "Mavluda opa",
  "variant.f01.family.groom.2.role": "Akasi",
  "variant.f01.family.groom.2.name": "Jasur",
  "variant.f01.family.bride.0.role": "Otasi",
  "variant.f01.family.bride.0.name": "Bahodir aka",
  "variant.f01.family.bride.1.role": "Onasi",
  "variant.f01.family.bride.1.name": "Munira opa",
  "variant.f01.family.bride.2.role": "Singlisi",
  "variant.f01.family.bride.2.name": "Madina",
  "variant.f01.schedule.0.event": "Kuyov tomon mehmonlari kelishi",
  "variant.f01.schedule.1.event": "Tantanali kirish · gullar va non",
  "variant.f01.schedule.2.event": "Quyma osh",
  "variant.f01.schedule.3.event": "Ota-onalar so'zlari",
  "variant.f01.schedule.4.event": "Sovg'a almashish",
  "variant.f01.schedule.5.event": "Yakuniy duo",
  "variant.f01.map.address": "Toshkent · kelin xonadoni · mahalla guzari",
  "variant.f01.rsvp.label": "Oilamizga qo'shilishingizni so'raymiz.",

  // ── variant.sn01 (Sunnat — Celebration) ───────────────────────────────
  "variant.sn01.hero.eyebrow": "SUNNAT TO'YI · MAHALLA BAYRAMI",
  "variant.sn01.hero.age": "{n} yoshda",
  "variant.sn01.dua.eyebrow": "DU'A & OQ YO'L",
  "variant.sn01.dua.title": "Behruzga tilaklarimiz",
  "variant.sn01.dua.intro": "Aziz qarindosh-urug', mahalla ahli — bizning Behruzimiz uchun bu kunda ayrilgan eng ezgu so'zlaringizni qabul qilamiz.",
  "variant.sn01.dua.0": "Allohning rahmati va barakoti sizga",
  "variant.sn01.dua.1": "Sog'lom va baxtli umr ko'ring",
  "variant.sn01.dua.2": "Ota-ona uchun ko'z nuri bo'ling",
  "variant.sn01.dua.3": "Yo'lingiz har doim oydin bo'lsin",
  "variant.sn01.dua.amen": "omin",
  "variant.sn01.schedule.0.event": "Mehmonlarni kutib olish · choyxona",
  "variant.sn01.schedule.1.event": "Sunnat marosimi",
  "variant.sn01.schedule.2.event": "Quyma palov",
  "variant.sn01.schedule.3.event": "Bolalar uchun o'yinlar",
  "variant.sn01.schedule.4.event": "Konsert va tabriklar",
  "variant.sn01.schedule.5.event": "Sovg'a topshirish",
  "variant.sn01.map.address": "Toshkent · 'Bahor' choyxonasi · mahalla guzari",
  "variant.sn01.rsvp.label": "Bayramda bizni quvontiring",

  // ── variant.g01 (Bitiruv — Academia) ──────────────────────────────────
  "variant.g01.hero.eyebrow": "BITIRUV MAROSIMI",
  "variant.g01.hero.institution": "UNIVERSITY OF INFORMATION TECHNOLOGIES",
  "variant.g01.story.eyebrow": "ta'lim safari",
  "variant.g01.story.title": "To'rt yillik mehnat",
  "variant.g01.story.body": "Sevinch 2022-yil avgustida TUITning Kompyuter injineriyasi fakultetiga qadam qo'ydi — Dasturiy injiniring yo'nalishi bo'yicha. To'rt yil davomida algoritmlar, ma'lumotlar bazalari, mashinaviy o'qitish va tabiiy tilni qayta ishlash bo'yicha kechalarini kompyuter qarshisida o'tkazdi. Birinchi kursda C++ da yozilgan kichik kompilyator, ikkinchi kursda jamoaviy hackathonda yutgan veb-platforma, uchinchi kursda IT Parkdagi staj. Endi diplom loyihasi — o'zbek tili uchun zamonaviy AI modeli — taqdim qilinmoqda. To'rt yil mehnat, minglab qatorlar kod, son-sanoqsiz qahva piyolasi — va bugun, oqqush libosida, oltin medal qo'lida, Sevinch akademik bitiruv marosimida nutq so'zlamoqda.",
  "variant.g01.achievements.eyebrow": "ACADEMIC RECORD",
  "variant.g01.achievements.title": "Yutuqlar",
  "variant.g01.achievements.0.label": "GPA 3.92 / 4.00",
  "variant.g01.achievements.0.detail": "Magna cum laude — fakultet eng yuqori 5%",
  "variant.g01.achievements.1.label": "Hackathon · 2-o'rin",
  "variant.g01.achievements.1.detail": "TUIT × IT Park · 2024-yil bahor",
  "variant.g01.achievements.2.label": "Diplom loyihasi",
  "variant.g01.achievements.2.detail": "AI for Uzbek language — transformer asosidagi modellar",
  "variant.g01.achievements.3.label": "Magna Cum Laude",
  "variant.g01.achievements.3.detail": "Akademik a'lochi · qizil diplom",
  "variant.g01.achievements.4.label": "Talabalar kengashi raisi",
  "variant.g01.achievements.4.detail": "2024 – 2026 · ikki muddat",
  "variant.g01.schedule.0.event": "Mehmonlarni kutib olish · TUIT katta zali",
  "variant.g01.schedule.1.event": "Bitiruv marosimi",
  "variant.g01.schedule.2.event": "Diplomni topshirish",
  "variant.g01.schedule.3.event": "Tantanali tushlik",
  "variant.g01.schedule.4.event": "Foto sessiya",
  "variant.g01.schedule.5.event": "Bitiruv kechki ovqati · oilada",
  "variant.g01.map.address": "TUIT · Toshkent · Amir Temur ko'chasi 108",
  "variant.g01.rsvp.label": "Sevinchni quvontiring",

  // ── variant.b03 (Bayramcha — Adult Birthday) ──────────────────────────
  "variant.b03.hero.eyebrow": "30 YOSH · TURNS THIRTY",
  "variant.b03.hero.age_label": "o'ttiz yoshli bayram",
  "variant.b03.story.eyebrow": "bir yil",
  "variant.b03.story.title": "Yangi o'n yillik",
  "variant.b03.story.body": "O'ttiz yosh — bir o'n yillikni yopib, yangisini ochish lahzasi. Bu kechada yonimda turgan eng aziz do'stlarim, sevgan oilam va har bir tabassumga sabab bo'lgan insonlarni ko'rmoqchiman. Sizlar — mening eng katta boyligimsiz. Birga bir qadah ko'taraylik, kelgusi o'n yillikka sokin va shukrona qalb bilan qadam qo'yamiz.",
  "variant.b03.cocktails.eyebrow": "SIGNATURE COCKTAILS",
  "variant.b03.cocktails.title": "Cocktail menyusi",
  "variant.b03.cocktails.outro": "…va albatta, asl champagne — kechaning yuragi.",
  "variant.b03.cocktails.0.name": "Nodira's Spritz",
  "variant.b03.cocktails.0.recipe": "prosecco · aperol · apelsin",
  "variant.b03.cocktails.1.name": "Charvak Sour",
  "variant.b03.cocktails.1.recipe": "viski · asal · limon",
  "variant.b03.cocktails.2.name": "Bahor Royale",
  "variant.b03.cocktails.2.recipe": "champagne · nok",
  "variant.b03.schedule.0.event": "Mehmonlarni kutib olish",
  "variant.b03.schedule.1.event": "Champagne ochilishi",
  "variant.b03.schedule.2.event": "Banket",
  "variant.b03.schedule.3.event": "Tort kesish",
  "variant.b03.schedule.4.event": "Raqs maydoni",
  "variant.b03.schedule.5.event": "After-party",
  "variant.b03.map.address": "Toshkent · 'Mascarpone Lounge' · Mustaqillik ko'chasi",
  "variant.b03.rsvp.label": "Bayramda kutamiz",

  // ── variant.c02 (Studio — Launch Event) ───────────────────────────────
  "variant.c02.story.title": "// about",
  "variant.c02.story.body": "Biz Toshkentdan startap qilamiz — and we're shipping our first real product to the world. PRODUCT × LAUNCH bu yerda yangi software platformasini debut qilamiz: built in O'zbekiston, designed for the region, engineered for global scale. Founders, engineers, designers, va investorlar bir xonada — to demo what we built, to share why now, va kimlar ishtirok etayotganini ko'rsatish uchun. Come for the live demo, stay for the panel. Code talks, hype walks. v1.0 ships tonight.",
  "variant.c02.roadmap.intro": "// what we're shipping. 0 → 1 in 12 months.",
  "variant.c02.roadmap.0.quarter": "2026 Q4",
  "variant.c02.roadmap.0.title": "Launch · v1.0",
  "variant.c02.roadmap.1.quarter": "2027 Q1",
  "variant.c02.roadmap.1.title": "Mobile apps · iOS + Android",
  "variant.c02.roadmap.2.quarter": "2027 Q2",
  "variant.c02.roadmap.2.title": "Open API",
  "variant.c02.roadmap.3.quarter": "2027 Q3",
  "variant.c02.roadmap.3.title": "Series A",
  "variant.c02.schedule.0.event": "Doors · check-in",
  "variant.c02.schedule.1.event": "Welcome talk",
  "variant.c02.schedule.2.event": "Live demo",
  "variant.c02.schedule.3.event": "Panel discussion",
  "variant.c02.schedule.4.event": "Networking",
  "variant.c02.schedule.5.event": "After-party",
  "variant.c02.map.address": "Toshkent · IT Park · Konferents zali",
  "variant.c02.hero.doors": "doors 19:00 · check-in opens",

  // ── variant.m02 (Yodgorlik — Reverent) ────────────────────────────────
  "variant.m02.hero.translit": "Innaa lillaahi va innaa ilayhi rojiun",
  "variant.m02.hero.uz_meaning": "\"Albatta, biz Allohnikimiz va albatta, biz Unga qaytguvchilarmiz.\" Aziz otamiz, bobomiz Olim Yusupovning xotira marosimiga sizni hurmat bilan taklif qilamiz.",
  "variant.m02.hero.marosim_label": "MAROSIM",
  "variant.m02.story.eyebrow": "hayot va meros",
  "variant.m02.story.title": "Olim Yusupovning xotirasiga",
  "variant.m02.story.body": "Olim Yusupov 1942-yilda Buxoroda tug'ilgan. U umrining qirq yilini Mir-i-Arab madrasasida arab tili va hadis ilmidan dars berib o'tkazdi — sokin, kamtar, lekin har bir talabasi yodida qoladigan ustoz edi. Rafiqasi Sa'odat opa bilan birga uchta farzandni voyaga yetkazdi va besh nabira ko'rishga muyassar bo'ldi. Eski shahar bog'larini kezish, Qur'on tilovati va dasturxonda yig'ilgan oilani kuzatish — uning eng katta sevinchlari edi. Bizdan jismonan ketdi, ammo so'zlari, sabri va duosi xonadonimizning har bir burchagida yashashda davom etadi.",
  "variant.m02.verses.eyebrow": "QUR'ON OYATLARI",
  "variant.m02.verses.title": "Marhumning haqqiga",
  "variant.m02.verses.0.uzbek": "Albatta, biz Allohnikimiz va albatta, biz Unga qaytguvchilarmiz.",
  "variant.m02.verses.0.reference": "AL-BAQARAH · 2:156",
  "variant.m02.verses.1.uzbek": "Har bir jon o'limni totuvchidir; va albatta, qiyomat kuni ajringizni to'liq olasiz.",
  "variant.m02.verses.1.reference": "OLI IMRON · 3:185",
  "variant.m02.verses.2.uzbek": "Ey, xotirjam jon! O'z Robbingga rozi bo'lib va rozilik olib qaytgin.",
  "variant.m02.verses.2.reference": "AL-FAJR · 89:27–28",
  "variant.m02.tributes.eyebrow": "OILA SO'ZLARI",
  "variant.m02.tributes.title": "Yaqinlarining xotirasida",
  "variant.m02.tributes.0.relation": "Rafiqasi",
  "variant.m02.tributes.0.name": "Sa'odat opa",
  "variant.m02.tributes.0.text": "Olim aka — qirq yil davomida hayotimizning eng quvonchli va eng og'ir kunlarida pastga qo'ymadi. Sukunatda ham, kulgida ham bizning poydevorimiz edi.",
  "variant.m02.tributes.1.relation": "O'g'li",
  "variant.m02.tributes.1.name": "Sherzod",
  "variant.m02.tributes.1.text": "Otam — bizning eng katta o'qituvchimiz edi. Madrasada talabalariga bergan ma'noni, biz uyda har kuni ko'rib o'sdik.",
  "variant.m02.tributes.2.relation": "Qizi",
  "variant.m02.tributes.2.name": "Munira",
  "variant.m02.tributes.2.text": "Otam asla shoshmas, hech kimni ortda qoldirmas edi. Buxoro ko'chalarida birga yurganimizda har bir tanishga salom berib bormoqni o'rgatgan edi.",
  "variant.m02.tributes.3.relation": "Nabirasi",
  "variant.m02.tributes.3.name": "Aziza",
  "variant.m02.tributes.3.text": "Bobomning eng sevimli kitoblari yonidagi javonida edi. Endi men o'qiyman, ovozini eshitganday bo'laman.",
  "variant.m02.map.address_suffix": "Marhum xonadoni · mahalla guzari",

  // ── variant.r01 (Mehmonxona — Restaurant Opening) ─────────────────────
  "variant.r01.hero.eyebrow": "GRAND OPENING",
  "variant.r01.hero.tagline": "Yangi Toshkent palovi",
  "variant.r01.story.eyebrow": "ochilish",
  "variant.r01.story.title": "Toshkentda yangi palov xonasi",
  "variant.r01.story.body": "'Palov & Co' — bu Toshkentning yuragida ochilayotgan yangi xonadon. Bosh oshpazimiz Bobur Karimov yigirma yillik tajribasini bir kosa palovga jamlagan: tanlanma uzun guruch, tog' yog'i, va Farg'ona vodiysidan keltirilgan sabzi. Biz uchun palov — bu shunchaki taom emas, balki dasturxon atrofida yig'ilish, kulgi, va mehmondo'stlik an'anasidir. Sizni bu yangi uyimizning birinchi mehmonlari bo'lishga taklif qilamiz.",
  "variant.r01.menu.eyebrow": "MENYU · OCHILISH KECHASI",
  "variant.r01.menu.title": "Birinchi dasturxon",
  "variant.r01.menu.disclaimer": "* Menyu mavsumiy va o'zgarishi mumkin",
  "variant.r01.menu.0.name": "Toshkent palovi",
  "variant.r01.menu.0.note": "",
  "variant.r01.menu.0.price": "65 000 so'm",
  "variant.r01.menu.1.name": "Manti",
  "variant.r01.menu.1.note": "qo'lda yopilgan",
  "variant.r01.menu.1.price": "35 000 so'm",
  "variant.r01.menu.2.name": "Lag'mon",
  "variant.r01.menu.2.note": "uyda bo'g'irtilgan",
  "variant.r01.menu.2.price": "32 000 so'm",
  "variant.r01.menu.3.name": "Norin",
  "variant.r01.menu.3.note": "",
  "variant.r01.menu.3.price": "28 000 so'm",
  "variant.r01.menu.4.name": "Choy",
  "variant.r01.menu.4.note": "samovardan",
  "variant.r01.menu.4.price": "8 000 so'm",
  "variant.r01.menu.5.name": "Halva",
  "variant.r01.menu.5.note": "uyda tayyorlangan",
  "variant.r01.menu.5.price": "18 000 so'm",
  "variant.r01.chef.eyebrow": "BOSH OSHPAZ",
  "variant.r01.chef.name": "Bobur Karimov",
  "variant.r01.chef.experience": "20 yillik tajriba",
  "variant.r01.chef.bio": "Farg'ona vodiysida tug'ilgan, Istanbul va Parijdagi mashhur restoranlarda ishlagan — endi o'z xonadonini Toshkentda ochmoqda. Uning palovi — an'ana va zamonaviy tafakkurning uyg'unligi.",
  "variant.r01.schedule.0.event": "Mehmonlarni kutib olish · choyxona dasturxoni",
  "variant.r01.schedule.1.event": "Restoran ochilishi · lenta kesilishi",
  "variant.r01.schedule.2.event": "Kechki ovqat menyusi",
  "variant.r01.schedule.3.event": "Bosh oshpaz so'zlari",
  "variant.r01.schedule.4.event": "Tirik musiqa · do'mbira",
  "variant.r01.schedule.5.event": "After-party",
  "variant.r01.map.address": "Toshkent · Mustaqillik ko'chasi 47 · 'Palov & Co' restorani",
  "variant.r01.rsvp.label": "Bizning birinchi mehmonimiz bo'ling",

  // ── variant.u01 (Yangi uy — Housewarming) ─────────────────────────────
  "variant.u01.hero.eyebrow": "YANGI UY · 2026",
  "variant.u01.hero.headline": "Karimovlar yangi uyiga sizni taklif qiladi",
  "variant.u01.hero.subtitle": "Yangi ostonadan birga qadam tashlaymiz — ahil oila, mehribon qo'ni-qo'shnilar, va dasturxonimiz atrofida iliq suhbat sizni kutadi.",
  "variant.u01.story.eyebrow": "bizning yangi uy",
  "variant.u01.story.title": "Birinchi yangi uyimiz",
  "variant.u01.story.body": "Uzoq yillar orzu qilingan kunimiz keldi — birinchi marta o'z uyimiz ostonasidan o'tdik. Devorlari yangi, hovlisi keng, eshigi har doim ochiq. Mehmondo'st xalqimizning eski an'anasi bo'yicha, yangi uyga oila a'zolari, qarindoshlar va qo'ni-qo'shnilar duo qilib, fotihasini berishi kerak. Shu sababli sizni — bizning yaqinlarimizni — uyimizning birinchi mehmonlari bo'lishga taklif qilamiz. Non-tuzimiz, mehrimiz va kulgimiz birga bo'lsin.",
  "variant.u01.tour.eyebrow": "UYIMIZNI KO'RSATAMIZ",
  "variant.u01.tour.title": "Yangi uyimizning to'rt burchagi",
  "variant.u01.tour.subtitle": "Har bir xona — bir hikoya. Sizni har biriga taklif qilamiz.",
  "variant.u01.tour.0.name": "Mehmonxona",
  "variant.u01.tour.0.note": "Sizni keng dasturxon va iliq suhbat kutadi.",
  "variant.u01.tour.1.name": "Oshxona",
  "variant.u01.tour.1.note": "Onamning palovi — uydan kelgan eng ajoyib hidi.",
  "variant.u01.tour.2.name": "Hovli",
  "variant.u01.tour.2.note": "Tut daraxti soyasida choy ichib, gurunglashamiz.",
  "variant.u01.tour.3.name": "Terrasa",
  "variant.u01.tour.3.note": "Kechki shamol va shaharning tinch chiroqlari.",
  "variant.u01.gifts.eyebrow": "AGAR XOHLASANGIZ",
  "variant.u01.gifts.title": "Yangi uy uchun hadiyalar",
  "variant.u01.gifts.subtitle": "An'anamizga ko'ra, yangi uyga foydali sovg'alar olib kelinadi. Sovg'a — majburiyat emas, lekin g'amxo'rlik qadamining belgisi.",
  "variant.u01.gifts.0.name": "Sochiq to'plami",
  "variant.u01.gifts.0.price": "120 000 – 180 000 so'm",
  "variant.u01.gifts.1.name": "Choy idishlari · piyolalar",
  "variant.u01.gifts.1.price": "150 000 – 250 000 so'm",
  "variant.u01.gifts.2.name": "Xona o'simligi (palma, monstera)",
  "variant.u01.gifts.2.price": "200 000 – 400 000 so'm",
  "variant.u01.gifts.3.name": "Choyshab · ko'rpa-yostiq jildi",
  "variant.u01.gifts.3.price": "180 000 – 350 000 so'm",
  "variant.u01.gifts.4.name": "Oshxona pichoqlari to'plami",
  "variant.u01.gifts.4.price": "250 000 – 500 000 so'm",
  "variant.u01.gifts.disclaimer": "* Eng yaxshi sovg'a — sizning duongiz va kulgingiz.",
  "variant.u01.schedule.0.event": "Mehmonlar kelishi · choy va shirinliklar",
  "variant.u01.schedule.1.event": "Dasturxon ochilishi · palov",
  "variant.u01.schedule.2.event": "Yangi uyni ko'rish · xonama-xona sayr",
  "variant.u01.schedule.3.event": "Musiqa va raqs · oilaviy suhbatlar",
  "variant.u01.schedule.4.event": "Chiqish duosi · oqsoqollar so'zi",
  "variant.u01.map.address": "Toshkent · Yunusobod tumani · Karimovlar mahallasi · 14-uy",
  "variant.u01.rsvp.label": "Yangi uyimizga keling",

  // ── Legal pages ───────────────────────────────────────────────────────
  "legal.updated": "Yangilangan",
  "legal.privacy.title": "Maxfiylik siyosati",
  "legal.privacy.h.collect": "Qanday ma'lumot yig'amiz",
  "legal.privacy.collect": "Taklifnoma yaratish va yetkazib berish uchun zarur bo'lgan minimal ma'lumotlarni yig'amiz:",
  "legal.privacy.collect.phone": "Hisobga kirish uchun email manzili.",
  "legal.privacy.collect.event": "Taklifnoma egasi kiritgan tadbir tafsilotlari (ismlar, sana, joy, fotosuratlar, musiqa).",
  "legal.privacy.collect.guests": "Mehmonlar kelishini tasdiqlaganlarida — ism, ishtirok holati, mehmonlar soni, ixtiyoriy izoh.",
  "legal.privacy.h.use": "Ma'lumotdan qanday foydalanamiz",
  "legal.privacy.use": "Sizning ma'lumotlaringiz faqat taklifnomani ko'rsatish, mehmon javoblarini saqlash va siz bilan zarur hollarda bog'lanish uchun ishlatiladi. Reklama yoki uchinchi tomonlarga sotmaymiz.",
  "legal.privacy.h.tracking": "Kuzatuv va analitika",
  "legal.privacy.tracking": "taklifla.uz uchinchi tomon analitika yoki marketing kuzatuvlaridan foydalanmaydi (Google Analytics, Facebook Pixel va shu kabilar yo'q). Faqat o'zimizning ichki ishlash logimiz mavjud.",
  "legal.privacy.h.retention": "Saqlash muddati",
  "legal.privacy.retention": "Taklifnomalar va mehmon javoblari sizning hisobingiz mavjud bo'lgan muddat davomida saqlanadi. Hisobni o'chirsangiz, barcha tegishli ma'lumotlar 30 kun ichida butunlay o'chiriladi.",
  "legal.privacy.h.contact": "Bog'lanish",
  "legal.privacy.contact": "Maxfiylik bilan bog'liq savollaringiz uchun:",

  "legal.terms.title": "Foydalanish shartlari",
  "legal.terms.h.service": "Xizmat haqida",
  "legal.terms.service": "taklifla.uz — bu raqamli taklifnomalar yaratish va ulashish platformasi. Yaratilgan taklifnomalar siz tanlagan shaxslarga havola orqali yuboriladi.",
  "legal.terms.h.tiers": "To'lov",
  "legal.terms.tiers": "Barcha shablonlar pullik. Har bir shablon uchun bir martalik to'lov olinadi — to'lov amalga oshirilgach taklifnoma muddatsiz mavjud bo'ladi. Sotib olingan taklifnoma taklifla.uz xizmati ishlab turgan vaqtgacha — ehtimol, butun umr davomida — mavjud bo'lib turadi; loyiha to'xtagan, sayt yopilgan yoki kompaniya faoliyati to'xtagan taqdirda biz taklifnomalarning onlayn qolishini kafolatlay olmaymiz.",
  "legal.terms.h.refund": "Pulni qaytarish",
  "legal.terms.refund": "Avtomatik pul qaytarish xizmati taqdim etilmaydi. Agar to'lov xato bilan amalga oshirilgan deb hisoblasangiz, Telegramdagi @taklifla_bot orqali qo'llab-quvvatlash xizmatiga vaziyatni tushuntirib yozing — har bir murojaatni alohida ko'rib chiqamiz. Qaytarish kafolatlanmaydi.",
  "legal.terms.h.responsibilities": "Foydalanuvchi mas'uliyati",
  "legal.terms.responsibilities": "Taklifnomada e'lon qilinayotgan barcha kontent (ismlar, manzillar, fotosuratlar) qonuniy va sizga tegishli ekanligini tasdiqlaysiz.",
  "legal.terms.h.contact": "Bog'lanish",
  "legal.terms.contact": "Shartlar bilan bog'liq savollar uchun:",

  // ── Document title (synced to locale by RootLayout) ────────────────────
  "doc.title": "taklifla.uz — chiroyli raqamli taklifnomalar",
};

export default uz;
